<template>
  <v-container fluid class="px-0">
    <v-expansion-panels v-model="searchPanel" class="mb-4" v-if="!loadDefault">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <v-row no-gutters>
            <v-col cols="4">
              Paieška
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <form @keydown.enter.prevent="submit()">
            <v-row class="mb-3">
              <v-col cols="12" md="4">
                <el-autocomplete
                  :items="vietaList"
                  itemvalue="value"
                  itemtext="text"
                  label="Rengimo vieta"
                  v-model="extraData.obj_sistema"
                />
              </v-col>
              <v-col cols="12" md="8">
                <el-autocomplete
                  :items="busenaObjektas"
                  itemvalue="value"
                  itemtext="text"
                  :multiple="true"
                  label="Pranešimo būsena"
                  v-model="extraData.zug_busena"
                  hide-details
                />
              </v-col>

              <v-col cols="12" md="4">
                <el-text-field
                  label="Dokumento Nr."
                  v-model="extraData.obj_dokumento_numeris"
                />
              </v-col>
              <v-col cols="12" md="4">
                <el-text-field
                  label="Dokumento ID"
                  v-model="extraData.obj_id"
                />
              </v-col>
              <v-col cols="12" md="4">
                <el-text-field
                  label="Identifikavimo kodas (IDK)"
                  v-model="extraData.obj_identifikavimo_kodas"
                  idk
                />
              </v-col>

              <v-col cols="12" md="12">
                <el-autocomplete
                  :items="filteredPranesimasRusys"
                  itemvalue="value"
                  itemtext="text"
                  label="Pranešimo rūšis"
                  :multiple="true"
                  v-model="extraData.obj_tipai"
                />
              </v-col>

              <v-col cols="12" md="4">
                <el-text-field label="Naudotojas" v-model="extraData.sukure" />
              </v-col>
              <v-col cols="12" md="4">
                <el-date-picker
                  label="Pradžios data nuo"
                  v-model="extraData.sukurimo_data_nuo"
                />
              </v-col>
              <v-col cols="12" md="4">
                <el-date-picker
                  label="Pradžios data iki"
                  v-model="extraData.sukurimo_data_iki"
                />
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="12">
                <el-button
                  :loading="loading"
                  primary
                  @click.native.stop="searchData()"
                >
                  Ieškoti
                </el-button>
                <el-button :loading="loading" @click.native="clearData()">
                  Išvalyti
                </el-button>
              </v-col>
            </v-row>
          </form>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TeikejasRengiamiSearch',
  props: {
    loading: Boolean,
  },
  data: () => ({
    searchPanel: null,
    loadDefault: null,
    mainData: {},
    extraData: {},
    pranesimas_rusys: [],
  }),
  computed: {
    ...mapGetters(['searchParams']),
    isExpanded() {
      return this.searchPanel === 0
    },
    vietaList() {
      return [
        {
          text: 'Darbo vieta',
          value: 1,
        },
        {
          text: 'Savitarna',
          value: 2,
        },
      ]
    },
    filteredPranesimasRusys() {
      return this.pranesimas_rusys.map(item => {
        return item
      })
    },
    busenaObjektas() {
      return [
        {
          value: 'rengiamas',
          text: 'Rengiamas',
        },
        {
          value: 'laukia_patvirtinimo',
          text: 'Laukia patvirtinimo',
        },
        {
          value: 'laukia_apmokejimo',
          text: 'Laukia apmokėjimo',
        },
        {
          value: 'perduotas',
          text: 'Perduotas',
        },
        {
          value: 'grazintas',
          text: 'Grąžintas',
        },
      ]
    },
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loadDefault = true

      const data = {
        klasifikatoriai: ['perduoti_rusys'],
      }

      this.$axios
        .post(`klasifikatorius/list`, data)
        .then(res => {
          this.pranesimas_rusys = res.data.list.perduoti_rusys

          if (
            this.searchParams &&
            this.searchParams.route === this.$route.name &&
            !this.searchParams.isNep
          ) {
            this.mainData = this.searchParams.mainData
            this.extraData = this.searchParams.extraData
            this.searchPanel = this.searchParams.isExpanded ? 0 : null
          }

          this.searchData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loadDefault = false
        })
    },
    searchData() {
      let searchData = {
        ...this.mainData,
        ...this.extraData,
      }

      this.$store.dispatch('searchParams', {
        route: this.$route.name,
        mainData: this.mainData,
        extraData: this.extraData,
        isExpanded: this.isExpanded,
      })

      this.$emit('search', searchData)
    },
    clearData() {
      this.mainData = {}
      this.extraData = {}
    },
    submit() {
      this.searchData()
    },
    clearRusis() {
      //
    },
  },
}
</script>
